import { render, staticRenderFns } from "./LuckyCoinFeed.vue?vue&type=template&id=1a8ec06c&scoped=true&"
import script from "./LuckyCoinFeed.vue?vue&type=script&lang=ts&"
export * from "./LuckyCoinFeed.vue?vue&type=script&lang=ts&"
import style0 from "./LuckyCoinFeed.vue?vue&type=style&index=0&id=1a8ec06c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8ec06c",
  null
  
)

export default component.exports